<template>
    <UiMapApiProductMap v-editable="blok" class="ui-product-map" :blok="blok" :products="products" :airport="airport" />
</template>

<script setup lang="ts">
import type { IAirportEntity, IAirportProducts } from '@nuxt-monorepo/ui/types';
import type { IApiProductMap } from '@nuxt-monorepo/ui/types/components/Map/ApiProductMap';

defineProps<{ blok: IApiProductMap }>();

const products: IAirportProducts = inject('productsList');
const airport: IAirportEntity = inject('airportData');
</script>

<style lang="postcss" scoped>
.ui-product-map.product-map :deep(.map-btn:not(.map-active) button) {
    @apply bg-btn hover:bg-btn-hover;
}
.ui-product-map {
    :deep(.map-container) {
        @apply max-sm:min-h-[90vh];
    }
}
</style>
